import React from 'react';
import { Button, Form, Input, Select, Space } from 'antd';
import { SaveOutlined } from '@ant-design/icons';
import { DB } from '@/script/moduleLen.js';
import dict from '@/script/dict.mjs';

// 创建对象
const DbData = () => {
}

DbData.dbUserCode = () => {
    return (
        <Form.Item name="dbUserCode" label="数据库代码" rules={[{ required: true }, { max: DB.dbUserCode }]}>
            <Input size="middle" placeholder="请输入数据库代码" />
        </Form.Item>
    );
}

DbData.dbName = () => {
    return (
        <Form.Item name="dbName" label="数据库名称" rules={[{ required: true }, { max: DB.dbName }]}>
            <Input size="middle" placeholder="请输入数据库名称" />
        </Form.Item>
    );
}

DbData.dbmsCode = () => {
    return (
        <Form.Item name="dbmsCode" label="数据库管理系统" rules={[{ required: true, message: '请选择数据库管理系统' }, { max: DB.dbmsCode }]}>
            <Select placeholder="请选择数据库管理系统">
                {
                    dict.getDictDtls('DB_TYPE')
                        .map(item => {
                            return <Option value={item.code}>{item.nameCn}</Option>
                        })
                }
            </Select>
        </Form.Item>
    );
}

DbData.memo = () => {
    return (
        <Form.Item name="memo" label="备注" rules={[{ max: DB.memo }]}>
            <Input.TextArea placeholder="请输入备注" rows="4" />
        </Form.Item>
    );
}

DbData.SaveButton = ({ onCancel, onSave }) => {
    return (
        <Space>
            <Button size="middle" type="primary" ghost onClick={onCancel}>取消</Button>
            <Button htmlType="submit" type="primary" size="middle" icon={<SaveOutlined />} onClick={onSave}>保存</Button>
        </Space>
    );
}

export default DbData;